// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as HomeContent from "./HomeContent.re.mjs";
import * as Core from "@linaria/core";
import * as HomeMolecules from "../../molecules/home/HomeMolecules.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

let logoBase = "https://static3.instapainting.com/images/press/mini-logos/";

function press() {
  return [
    [
      "wired.png",
      "wired@2x.png",
      t`Wired Magazine Instapainting Robo Painter`
    ],
    [
      "techcrunch.png",
      "techcrunch.png",
      t`Instapainting.com on Techcrunch`
    ],
    [
      "engadget.png",
      "engadget@2x.png",
      t`Instapainting.com AI Painter on Engadget`
    ],
    [
      "backchannel.png",
      "backchannel@2x.png",
      t`Instapainting.com on Backchannel`
    ],
    [
      "artnet.png",
      "artnet@2x.png",
      t`Intrepid Robot Artist Creates 36-Hour Crowd-Sourced Painting`
    ],
    [
      "mental_floss.png",
      "mental_floss@2x.png",
      t`A Robot Spent 36 Hours Painting This Abstract Masterpiece`
    ]
  ];
}

function SocialProofSection(props) {
  let reviews = props.reviews;
  let count = HomeContent.formatCount(props.totalCount);
  let press$1 = press();
  return JsxRuntime.jsx("section", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
              children: t`As Featured In`,
              className: Core.cx("text-center mb-10 md:mb-12")
            }),
            JsxRuntime.jsx("div", {
              children: press$1.map(param => {
                let logo = param[0];
                return JsxRuntime.jsx(HomeMolecules.PressLogo.make, {
                  src: logoBase + logo,
                  srcSet: logoBase + param[1] + ` 2x`,
                  alt: param[2]
                }, logo);
              }),
              className: Core.cx("grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-y-8 gap-x-6 items-center justify-items-center")
            })
          ],
          className: Core.cx("border-t border-gray-200 pt-12 md:pt-16 mb-24 md:mb-32")
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
                      children: t`Customer Reviews`,
                      className: Core.cx("mb-2")
                    }),
                    JsxRuntime.jsx(HomeAtoms.SerifHeading.make, {
                      level: 3,
                      children: t`What our customers say`,
                      className: Core.cx("text-3xl md:text-4xl")
                    })
                  ]
                }),
                JsxRuntime.jsx("p", {
                  children: t`Over ${count} photo to painting reviews`,
                  className: Core.cx("hidden md:block text-xs tracking-wide text-gray-500 font-light italic whitespace-nowrap")
                })
              ],
              className: Core.cx("flex items-end justify-between mb-10 md:mb-12 border-b border-gray-200 pb-4 gap-6")
            }),
            reviews.length === 0 ? null : JsxRuntime.jsx("div", {
                children: reviews.map(review => JsxRuntime.jsx(HomeMolecules.ReviewCard.make, {
                  review: review
                }, review.link)),
                className: Core.cx("grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12")
              }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("p", {
                  children: [
                    t`Over`,
                    " ",
                    JsxRuntime.jsx("span", {
                      children: count,
                      className: Core.cx("text-gray-900 not-italic")
                    }),
                    " ",
                    t`photo to painting reviews`
                  ],
                  className: Core.cx("text-sm md:text-base text-gray-600 font-light italic")
                }),
                JsxRuntime.jsx(HomeAtoms.ArrowLink.make, {
                  href: HomeContent.reviewsLink,
                  label: t`View More Reviews`
                })
              ],
              className: Core.cx("mt-12 md:mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-gray-200 pt-8")
            })
          ]
        })
      ],
      className: Core.cx("max-w-6xl mx-auto")
    }),
    className: Core.cx("w-full bg-[#faf9f6] px-6 md:px-12 pb-24 md:pb-32")
  });
}

let make = SocialProofSection;

export {
  logoBase,
  press,
  make,
}
/*  Not a pure module */
